{
  "meta": {
    "manager": {
      "name": "Morgan Ellis",
      "first_name": "Morgan"
    },
    "report": {
      "name": "Avery Chen",
      "first_name": "Avery",
      "role": "Product Designer",
      "tenure": "~11 months"
    },
    "period": {
      "start": "2025-07-14",
      "end": "2026-02-24"
    },
    "generated": "2026-03-06",
    "data_counts": {
      "meetings": 7,
      "work_summaries": 8,
      "goals": 3,
      "checkins": 3,
      "recognitions": 1
    }
  },
  "sources": [
    {
      "type": "meeting",
      "title": "Morgan / Avery 1:1 — Wireframe review and sprint priorities",
      "source_ref": "meeting_5201"
    },
    {
      "type": "meeting",
      "title": "Morgan / Avery 1:1 — Stakeholder debrief and settings page",
      "source_ref": "meeting_5202"
    },
    {
      "type": "meeting",
      "title": "Morgan / Avery 1:1 — User research findings and ad-hoc requests",
      "source_ref": "meeting_5203"
    },
    {
      "type": "meeting",
      "title": "Morgan / Avery 1:1 — Dev handoff and ad-hoc request escalation",
      "source_ref": "meeting_5204"
    },
    {
      "type": "meeting",
      "title": "Morgan / Avery 1:1 — Settings page, perf cycle, intake process",
      "source_ref": "meeting_5205"
    },
    {
      "type": "meeting",
      "title": "Morgan / Avery 1:1 — Onboarding launch results and Q1 priorities",
      "source_ref": "meeting_5206"
    },
    {
      "type": "meeting",
      "title": "Morgan / Avery 1:1 — Design system, burnout, career growth",
      "source_ref": "meeting_5207"
    },
    {
      "type": "goal",
      "title": "Ship onboarding redesign and improve activation rate by 15%",
      "source_ref": "goal_3201"
    },
    {
      "type": "goal",
      "title": "Complete settings page redesign",
      "source_ref": "goal_3202"
    },
    {
      "type": "goal",
      "title": "Build and document core design system component library (30 components)",
      "source_ref": "goal_3203"
    },
    {
      "type": "recognition",
      "title": "Exceptional Figma handoff on onboarding redesign",
      "source_ref": "recognition_4201"
    },
    {
      "type": "checkin",
      "title": "Onboarding goal check-in — progress to 45%",
      "source_ref": "checkin_6201"
    },
    {
      "type": "checkin",
      "title": "Onboarding goal check-in — progress to 80%",
      "source_ref": "checkin_6202"
    },
    {
      "type": "checkin",
      "title": "Onboarding goal check-in — completed at 100%",
      "source_ref": "checkin_6203"
    },
    {
      "type": "work_summary",
      "title": "Week of Jul 7 — Onboarding discovery and wireframing",
      "source_ref": "work_summary_7201"
    },
    {
      "type": "work_summary",
      "title": "Week of Aug 4 — Stakeholder review and research planning",
      "source_ref": "work_summary_7202"
    },
    {
      "type": "work_summary",
      "title": "Week of Aug 25 — User research sessions complete",
      "source_ref": "work_summary_7203"
    },
    {
      "type": "work_summary",
      "title": "Week of Sep 29 — Dev handoff and settings audit",
      "source_ref": "work_summary_7204"
    },
    {
      "type": "work_summary",
      "title": "Week of Nov 10 — Settings hi-fi and onboarding support",
      "source_ref": "work_summary_7205"
    },
    {
      "type": "work_summary",
      "title": "Week of Dec 15 — Onboarding launch",
      "source_ref": "work_summary_7206"
    },
    {
      "type": "work_summary",
      "title": "Week of Jan 13 — Design system kickoff",
      "source_ref": "work_summary_7207"
    },
    {
      "type": "work_summary",
      "title": "Week of Feb 17 — Design system progress, stretched thin",
      "source_ref": "work_summary_7208"
    }
  ],
  "dashboard": [
    {
      "dimension": "Career Growth",
      "icon": "🌱",
      "status": "critical",
      "status_label": "Stalled",
      "detail": "7 months, no development plan"
    },
    {
      "dimension": "Workload Balance",
      "icon": "⚖️",
      "status": "critical",
      "status_label": "Burnout Risk",
      "detail": "Working evenings, 3 parallel streams"
    },
    {
      "dimension": "Blockers & Support",
      "icon": "🚧",
      "status": "alert",
      "status_label": "Slow Response",
      "detail": "Ad-hoc blocker took 4 months"
    },
    {
      "dimension": "Psychological Safety",
      "icon": "🛡️",
      "status": "alert",
      "status_label": "Eroding",
      "detail": "Concerns raised, action delayed"
    },
    {
      "dimension": "Feedback & Recognition",
      "icon": "🏅",
      "status": "alert",
      "status_label": "Under-recognized",
      "detail": "Major launch, no visibility push"
    },
    {
      "dimension": "Decision Making",
      "icon": "⚡",
      "status": "warn",
      "status_label": "Slow",
      "detail": "Career and scope decisions looping"
    },
    {
      "dimension": "Frequency Health",
      "icon": "📅",
      "status": "warn",
      "status_label": "Gaps Present",
      "detail": "Avg 5-6 week intervals"
    },
    {
      "dimension": "Energy Alignment",
      "icon": "🔥",
      "status": "warn",
      "status_label": "Draining Mix",
      "detail": "Energized by craft, drained by ad-hoc"
    },
    {
      "dimension": "Autonomy & Delegation",
      "icon": "🎯",
      "status": "warn",
      "status_label": "Under-supported",
      "detail": "High autonomy, insufficient backup"
    },
    {
      "dimension": "Personal Connection",
      "icon": "💙",
      "status": "warn",
      "status_label": "Surface Level",
      "detail": "No personal topics in data"
    },
    {
      "dimension": "Meeting Structure",
      "icon": "📋",
      "status": "warn",
      "status_label": "Improvable",
      "detail": "Career topics keep getting cut"
    },
    {
      "dimension": "Expectations Tracker",
      "icon": "🎯",
      "status": "warn",
      "status_label": "Drift Risk",
      "detail": "Settings page overdue, no plan update"
    },
    {
      "dimension": "Talk Ratio",
      "icon": "🎙️",
      "status": "good",
      "status_label": "Balanced",
      "detail": "Avery drives most topics"
    },
    {
      "dimension": "Team Dynamics",
      "icon": "🤝",
      "status": "warn",
      "status_label": "Narrow",
      "detail": "Only 1 close collaborator (Suki)"
    }
  ],
  "dimensions": [
    {
      "name": "Career Growth",
      "icon": "🌱",
      "status": "critical",
      "insights": [
        {
          "title": "Seven months of career questions with no concrete plan",
          "priority": "high",
          "body": "Avery first raised the senior designer promotion question in September 2025. Over the next seven months, the topic was raised in at least three meetings (Sep 8, Nov 17, Feb 24) and was either tabled, answered vaguely, or deflected. There is still no written development plan, no rubric shared, and no clear answer on promotion candidacy. Avery's own notes reveal growing frustration and mention of exploring external opportunities.",
          "evidence": [
            {
              "text": "Sep 8: Career development tabled — 'we ran out of time.' Avery noted: 'This is the second time career growth got pushed off.'",
              "source_ref": "meeting_5203"
            },
            {
              "text": "Nov 17: Morgan said 'consistent impact and maybe leading a project end-to-end' but couldn't point to a rubric. Avery noted: 'The feedback was nice but vague.'",
              "source_ref": "meeting_5205"
            },
            {
              "text": "Feb 24: Avery asked directly about senior promotion. Morgan said 'let me check with my manager.' Avery noted: 'Seven months of asking... I'm starting to look at what's out there.'",
              "source_ref": "meeting_5207"
            }
          ],
          "action": {
            "label": "Open Next Meeting With",
            "text": "Avery, I owe you a real answer on the senior designer path, and I'm sorry it's taken this long. I want to share where things stand honestly — whether it's this cycle or the next — and build a concrete development plan together with specific milestones. You deserve clarity, not vagueness.",
            "variant": "default"
          }
        },
        {
          "title": "No growth-oriented goals exist",
          "priority": "high",
          "body": "All three of Avery's goals are delivery-focused (onboarding redesign, settings page, design system). None explicitly target personal development such as building leadership skills, deepening user research expertise, or developing mentorship capacity. For someone at the 6-18 month mark actively pursuing a promotion, at least one goal should be growth-oriented.",
          "evidence": [
            {
              "text": "Goal set includes onboarding redesign (100% complete), settings page (60%), and design system (40%) — all delivery goals.",
              "source_ref": "goal_3201"
            },
            {
              "text": "Avery has demonstrated growth behaviors independently (running user research end-to-end, creating research reports) but these aren't captured as development objectives.",
              "source_ref": "meeting_5203"
            }
          ],
          "action": {
            "label": "Suggested Discussion Topic",
            "text": "Avery, I want us to create at least one goal that's specifically about your growth — not just delivering a project, but building a skill that gets you closer to senior level. What area would be most meaningful to you? Leading cross-functional projects? Deepening your research practice? Mentoring?",
            "variant": "default"
          }
        },
        {
          "title": "Perf review results never properly shared",
          "priority": "medium",
          "body": "In the January 12 meeting, Avery asked about the perf review outcome. Morgan said it 'went well' but didn't share specifics or the written review, promising to forward it 'when HR sends it.' By the February 24 meeting, there's no indication it was ever shared. This erodes trust — Avery is left guessing about how they're perceived.",
          "evidence": [
            {
              "text": "Jan 12: Morgan said 'it went well, you got positive feedback' but didn't share specifics. Avery noted: 'Still haven't seen my written review.'",
              "source_ref": "meeting_5206"
            }
          ],
          "action": {
            "label": "Manager Action",
            "text": "Before the next 1-on-1, locate Avery's written performance review and share it. Walk through the feedback together in the meeting — both the strengths and the growth areas. This is foundational to the career development conversation.",
            "variant": "default"
          }
        }
      ]
    },
    {
      "name": "Workload Balance",
      "icon": "⚖️",
      "status": "critical",
      "insights": [
        {
          "title": "Burnout is not a risk — it's happening now",
          "priority": "high",
          "body": "Avery is carrying three concurrent workstreams (design system, settings page bugs, ad-hoc requests), working evenings to keep up, and explicitly flagged burnout in the February 24 meeting. Morgan's response — suggesting a long weekend — addresses symptoms but not the structural cause. Avery's own note is clear: 'A long weekend won't fix this. I need fewer things on my plate.' This requires immediate workload reduction, not rest.",
          "evidence": [
            {
              "text": "Feb 24: Avery flagged burnout — 'carrying the design system, settings page bug fixes, and still getting occasional ad-hoc requests.' Working evenings.",
              "source_ref": "meeting_5207"
            },
            {
              "text": "Week of Feb 17: 'Pace is slower than projected — carrying too many parallel workstreams. Working evenings to stay on track.'",
              "source_ref": "work_summary_7208"
            },
            {
              "text": "Avery's note: 'I need fewer things on my plate, not a break from all of them. I wish Morgan would actually cut scope or bring in help.'",
              "source_ref": "meeting_5207"
            }
          ],
          "action": {
            "label": "Open Next Meeting With",
            "text": "Avery, I dropped the ball on your burnout concern last time. Suggesting a long weekend was a band-aid — you told me you need fewer things on your plate, and you're right. Let's go through everything you're carrying and explicitly decide what gets paused, cut, or handed off. I should be the one protecting your capacity, not asking you to push through.",
            "variant": "default"
          }
        },
        {
          "title": "Context-switching across 3+ workstreams consistently",
          "priority": "high",
          "body": "Since November, Avery has been juggling 3-4 parallel workstreams in most weeks: design system, settings page, onboarding dev support, and ad-hoc requests. The design system work — which Avery is excited about — is being slowed by this fragmentation. Work summaries show the pattern clearly: high-quality output but at an unsustainable personal cost.",
          "evidence": [
            {
              "text": "Week of Nov 10: Settings hi-fi + onboarding dev support (8 questions) + 2-3 ad-hoc sales requests = 3 workstreams",
              "source_ref": "work_summary_7205"
            },
            {
              "text": "Week of Jan 13: Design system + settings page bug fixes = 2 workstreams with unplanned work",
              "source_ref": "work_summary_7207"
            },
            {
              "text": "Week of Feb 17: Design system progress 'slower than projected — carrying too many parallel workstreams'",
              "source_ref": "work_summary_7208"
            }
          ],
          "action": {
            "label": "Manager Action",
            "text": "Make a clear prioritization call: design system is the Q1 priority, so settings page bugs should be batched into a specific window or reassigned. Block Avery's calendar from ad-hoc requests entirely. If you can't cut the work, you need to bring in help — a contractor, a shared designer, something.",
            "variant": "default"
          }
        },
        {
          "title": "Ad-hoc sales requests improved but not fully resolved",
          "priority": "medium",
          "body": "The intake process established in November reduced ad-hoc requests from 4-5 per week to 1 initially, but requests are still 'leaking through' as of February. The structural fix helped but isn't fully enforced. This represents 4+ months of cumulative distraction that could have been addressed faster.",
          "evidence": [
            {
              "text": "Nov 17: Intake process established — 'only 1 request came through vs. the usual 4-5'",
              "source_ref": "meeting_5205"
            },
            {
              "text": "Week of Nov 10: 'Still getting 2-3 ad-hoc sales requests per week despite raising this with Morgan'",
              "source_ref": "work_summary_7205"
            },
            {
              "text": "Feb 24: 'Still getting occasional ad-hoc requests that slip through the intake process'",
              "source_ref": "meeting_5207"
            }
          ],
          "action": {
            "label": "Manager Action",
            "text": "Enforce the intake process with the sales VP directly. Any request that doesn't go through the form gets bounced back by you — not by Avery. Make it clear to sales that Avery is off-limits for direct requests.",
            "variant": "default"
          }
        }
      ]
    },
    {
      "name": "Blockers & Support",
      "icon": "🚧",
      "status": "alert",
      "insights": [
        {
          "title": "The ad-hoc request blocker took 4 months to resolve — and it's still not fully fixed",
          "priority": "high",
          "body": "Avery first raised ad-hoc sales requests as a significant time drain on August 11. Morgan acknowledged it each time it came up (Sep 8, Oct 6) but took no concrete action until November 17 — four months later. The delay cost Avery roughly 120-160 hours of design time based on the 8-10 hours/week estimate. Even now, requests still leak through. When a report raises a blocker and the manager sympathizes but doesn't act, it teaches the report that raising issues is futile.",
          "evidence": [
            {
              "text": "Aug 11: Avery first flagged ad-hoc requests — 'Would be nice to have a process for triaging these so I can protect focus time'",
              "source_ref": "meeting_5202"
            },
            {
              "text": "Sep 8: Raised again — '4-5 per week, eating 8-10 hours/week.' Morgan said 'let me think about how to handle this' — no action.",
              "source_ref": "meeting_5203"
            },
            {
              "text": "Oct 6: Raised a third time. Morgan suggested Avery 'start saying no directly.' Avery noted: 'I don't feel comfortable pushing back on the sales VP without Morgan backing me up.'",
              "source_ref": "meeting_5204"
            },
            {
              "text": "Nov 17: Intake process finally established — 4 months after first raised.",
              "source_ref": "meeting_5205"
            }
          ],
          "action": {
            "label": "Suggested Discussion Topic",
            "text": "Avery, I want to acknowledge something — it took me way too long to fix the ad-hoc request problem. You raised it four times before I put a real solution in place. That's on me. Going forward, when you flag something as a blocker, I'm going to treat it with more urgency. Is there anything else right now that's in that 'I've mentioned it but nothing's changed' category?",
            "variant": "default"
          }
        },
        {
          "title": "Morgan offered to sit in on user research but didn't follow through",
          "priority": "medium",
          "body": "In the August 11 meeting, Morgan offered to sit in on one of the five user research sessions but didn't commit to a specific session and ultimately never attended. Avery noted feeling proud of running research solo but also wishing Morgan had participated. This was a missed opportunity to both support Avery's development and demonstrate investment in their work.",
          "evidence": [
            {
              "text": "Aug 11: 'Morgan offered to sit in on one but didn't commit to a specific session.'",
              "source_ref": "meeting_5202"
            },
            {
              "text": "Sep 8: Avery's note: 'Really proud of these insights. First time running research end-to-end on my own. Wish Morgan had sat in on at least one session though.'",
              "source_ref": "meeting_5203"
            }
          ],
          "action": {
            "label": "Manager Action",
            "text": "When you commit to attending something — even casually — put it on your calendar immediately. Dropped commitments erode trust even when they seem minor. For the upcoming settings page user testing, ask Avery if you can sit in on a session and actually schedule it.",
            "variant": "default"
          }
        },
        {
          "title": "Burnout response was insufficient — suggest rest instead of cutting scope",
          "priority": "high",
          "body": "When Avery raised burnout on February 24, Morgan suggested 'take a long weekend' rather than addressing the root cause: too much work for one person. This is a common manager mistake — treating overwork as a rest problem rather than a scope problem. The blocker here is the workload itself, and only Morgan has the authority to reduce it.",
          "evidence": [
            {
              "text": "Feb 24: Morgan suggested Avery 'take a long weekend' but didn't discuss workload redistribution or deprioritization.",
              "source_ref": "meeting_5207"
            },
            {
              "text": "Avery's note: 'A long weekend won't fix this. I need fewer things on my plate, not a break from all of them.'",
              "source_ref": "meeting_5207"
            }
          ],
          "action": {
            "label": "Manager Action",
            "text": "Come to the next meeting with a concrete proposal: which workstream gets paused, deferred, or reassigned. Present it to Avery and ask if it would actually help. Don't put the burden of prioritization on the person who is already overwhelmed.",
            "variant": "default"
          }
        }
      ]
    },
    {
      "name": "Psychological Safety",
      "icon": "🛡️",
      "status": "alert",
      "insights": [
        {
          "title": "Avery raises concerns consistently — but the response cycle is damaging trust",
          "priority": "high",
          "body": "Avery demonstrates strong psychological safety signals: they raise uncomfortable topics (ad-hoc workload, burnout, career frustration), push back on suggestions they disagree with (refusing to push back on sales VP alone), and express genuine vulnerability. This is excellent — and rare. The problem is on the response side. Concerns raised multiple times without action teach the report that speaking up doesn't lead to change. The trajectory visible in Avery's notes shows eroding trust: from hopeful ('would be nice to have a process') to frustrated ('took 4 months') to flight risk ('starting to look at what's out there').",
          "evidence": [
            {
              "text": "Aug 11: Avery raises ad-hoc requests for the first time — constructive tone, specific suggestion.",
              "source_ref": "meeting_5202"
            },
            {
              "text": "Oct 6: Avery pushes back on Morgan's suggestion to say no directly to sales VP — 'I don't feel comfortable without Morgan backing me up.' This is healthy pushback.",
              "source_ref": "meeting_5204"
            },
            {
              "text": "Feb 24: Avery asks directly about promotion. Note: 'Seven months of asking... I'm starting to look at what's out there.'",
              "source_ref": "meeting_5207"
            }
          ],
          "action": {
            "label": "Suggested Discussion Topic",
            "text": "Avery, I value how honest you are with me — raising the ad-hoc problem, flagging burnout, pushing me on the career question. That takes courage and I don't take it for granted. I also know I haven't always followed through as fast as I should have. I want to do better. Can you tell me — is there anything else you've been holding back because you're not sure it'll lead to action?",
            "variant": "default"
          }
        },
        {
          "title": "Avery's private notes reveal a gap between what's said and what's felt",
          "priority": "high",
          "body": "Throughout the data, Avery's individual notes contain significantly more candid assessments than what appears in the discussion notes. The disappointment about Morgan not attending research sessions, the frustration about vague career feedback, the despair about the promotion timeline — these are thoughts Avery has but may not be expressing fully in the meeting. This gap is a leading indicator of withdrawal.",
          "evidence": [
            {
              "text": "Sep 8 note: 'Wish Morgan had sat in on at least one session though' — not raised directly.",
              "source_ref": "meeting_5203"
            },
            {
              "text": "Nov 17 note: 'The feedback was nice but vague... I still don't know what the gap is' — partially raised but Avery may not have pressed hard.",
              "source_ref": "meeting_5205"
            },
            {
              "text": "Jan 12 note: 'A bit disappointed Morgan didn't suggest sharing this at all-hands... I feel like this work is invisible outside our team.'",
              "source_ref": "meeting_5206"
            }
          ],
          "action": {
            "label": "Suggested Discussion Topic",
            "text": "Avery, I want to make sure I'm hearing not just what you say in our meetings but what you're really thinking. Sometimes I worry I'm missing things because you're being polite. What's one thing you wish I was doing differently as your manager?",
            "variant": "default"
          }
        }
      ]
    },
    {
      "name": "Feedback & Recognition",
      "icon": "🏅",
      "status": "alert",
      "insights": [
        {
          "title": "Onboarding launch — a major win with no visibility push",
          "priority": "high",
          "body": "The onboarding redesign exceeded its target (18% activation improvement vs. 15% goal), was praised during development, and represents months of end-to-end design work. Yet when it launched, Morgan congratulated Avery in the 1-on-1 but didn't suggest sharing the success at all-hands, writing a case study, or otherwise creating visibility. Avery explicitly noted feeling the work was 'invisible outside our team.' For a designer pursuing a senior promotion, external visibility of impact is critical — and that's the manager's job to create.",
          "evidence": [
            {
              "text": "Jan 12: 'Morgan congratulated Avery but didn't discuss recognition or visibility for the win.'",
              "source_ref": "meeting_5206"
            },
            {
              "text": "Avery's note: 'Really proud of these numbers. A bit disappointed Morgan didn't suggest sharing this at all-hands or writing it up.'",
              "source_ref": "meeting_5206"
            },
            {
              "text": "Activation rate up 18%, email verification drop-off cut from 30% to 12%, time-to-first-value reduced by 2 minutes.",
              "source_ref": "meeting_5206"
            }
          ],
          "action": {
            "label": "Manager Action",
            "text": "Immediately create visibility for Avery's onboarding redesign results. Options: nominate Avery to present at the next all-hands, write a Slack post highlighting the metrics and tagging Avery, or ask Avery to write a case study that leadership will see. This directly supports the senior promotion case.",
            "variant": "default"
          }
        },
        {
          "title": "Only one formal recognition in 8 months of exceptional work",
          "priority": "high",
          "body": "Across 8 months, there is only one recorded recognition (the Figma handoff praise). Avery has delivered a successful product launch, run user research independently for the first time, earned praise from the VP of Product, and is building the company's design system. Each of these merits specific recognition. The engineering lead's praise was captured, but Morgan's own recognition of Avery's broader contributions is sparse in the data.",
          "evidence": [
            {
              "text": "Only recognition: 'Engineering lead called Avery's Figma handoff the most thorough handoff we've received.'",
              "source_ref": "recognition_4201"
            },
            {
              "text": "Avery ran 5 user research sessions end-to-end for the first time — milestone not formally recognized.",
              "source_ref": "meeting_5203"
            },
            {
              "text": "VP Product praised the onboarding wireframes at stakeholder review — positive but not turned into lasting recognition.",
              "source_ref": "meeting_5202"
            }
          ],
          "action": {
            "label": "Manager Action",
            "text": "Start a recognition cadence: aim for at least one specific recognition per month. Right now, recognize: (1) the onboarding launch exceeding targets, (2) Avery's first end-to-end user research project, and (3) the design system initiative. Be specific about the behavior and the impact — not just 'great job.'",
            "variant": "green"
          }
        },
        {
          "title": "Constructive feedback is absent — career growth suffers",
          "priority": "medium",
          "body": "There is no recorded instance of Morgan providing constructive or developmental feedback to Avery. All feedback is positive ('great work', 'on the right track'). While Avery is performing well, the absence of growth-oriented feedback means Avery doesn't know what to improve. This directly explains why the 'what do I need for senior' question goes unanswered — Morgan hasn't identified or communicated specific gaps.",
          "evidence": [
            {
              "text": "Nov 17: Morgan said Avery is 'doing great work' and 'on the right track' but couldn't point to specific gaps for senior level.",
              "source_ref": "meeting_5205"
            },
            {
              "text": "No constructive feedback instances found across all 7 meetings.",
              "source_ref": null
            }
          ],
          "action": {
            "label": "Suggested Discussion Topic",
            "text": "Avery, I've been telling you you're doing great — and you are — but I haven't been giving you enough feedback on where you can grow. That's a failure on my part. I've been thinking about what would stretch you toward senior level, and I want to share some specific observations. Can we dedicate 15 minutes to that next time?",
            "variant": "default"
          }
        }
      ]
    },
    {
      "name": "Decision Making",
      "icon": "⚡",
      "status": "warn",
      "insights": [
        {
          "title": "Career path decision has looped for 7 months with no resolution",
          "priority": "high",
          "body": "The senior promotion question has been raised in at least three meetings without a clear decision. Each time, the response was a deferral ('we should talk about that', 'let me check with my manager'). This is the textbook 'discussion loop' — the topic gets airtime but never gets decided. Every cycle without a clear answer increases the risk of losing Avery.",
          "evidence": [
            {
              "text": "Sep 8: Career topic tabled — 'ran out of time'",
              "source_ref": "meeting_5203"
            },
            {
              "text": "Nov 17: Vague criteria given — 'consistent impact and maybe leading a project end-to-end'",
              "source_ref": "meeting_5205"
            },
            {
              "text": "Feb 24: 'Am I being considered?' → 'I think so, let me check with my manager.' Still no decision.",
              "source_ref": "meeting_5207"
            }
          ],
          "action": {
            "label": "Manager Action",
            "text": "Before the next 1-on-1, get a definitive answer from your manager: Is Avery being considered for senior designer this cycle? If yes, what's the timeline? If no, what specifically needs to happen first? Come to the meeting with a clear, honest answer — even if it's not what Avery wants to hear. Ambiguity is worse than bad news.",
            "variant": "default"
          }
        },
        {
          "title": "Workload prioritization is discussed but never decided",
          "priority": "medium",
          "body": "Multiple meetings touch on Avery's workload being too heavy, but no clear prioritization decision is made. In July, 3 active projects were acknowledged without deciding what to drop. In August, the settings page was pushed to September without discussing impact. In February, burnout was flagged without scope cuts. The pattern is consistent: acknowledge the problem, express sympathy, but don't make a call.",
          "evidence": [
            {
              "text": "Jul 14: 'Morgan acknowledged the load but didn't discuss prioritization or what to drop.'",
              "source_ref": "meeting_5201"
            },
            {
              "text": "Aug 11: Settings page pushed to September — 'No discussion of how this affects the original timeline or Avery's other commitments.'",
              "source_ref": "meeting_5202"
            },
            {
              "text": "Feb 24: Burnout flagged — Morgan 'didn't discuss workload redistribution or deprioritization.'",
              "source_ref": "meeting_5207"
            }
          ],
          "action": {
            "label": "Suggested Discussion Topic",
            "text": "Avery, I've been acknowledging your workload concerns without actually making tough calls. That's not fair to you. Here's what I think we should do: [propose specific prioritization]. But I want to hear your take — what would you cut or defer if you could only focus on two things?",
            "variant": "default"
          }
        }
      ]
    },
    {
      "name": "Frequency Health",
      "icon": "📅",
      "status": "warn",
      "insights": [
        {
          "title": "Meeting cadence averages 5-6 weeks — far too infrequent",
          "priority": "high",
          "body": "Seven meetings over approximately 7.5 months yields an average interval of about 32 days. The gaps are significant: 28 days (Jul→Aug), 28 days (Aug→Sep), 28 days (Sep→Oct), 42 days (Oct→Nov), 56 days (Nov→Jan), and 43 days (Jan→Feb). For someone at the 6-18 month tenure mark who is navigating career questions, workload issues, and active projects, biweekly meetings should be the minimum. The long gaps directly contributed to blocker resolution delays and career conversation drift.",
          "evidence": [
            {
              "text": "Oct 6 to Nov 17: 42-day gap during which settings page hi-fi designs were completed and ad-hoc request problem persisted.",
              "source_ref": "meeting_5205"
            },
            {
              "text": "Nov 17 to Jan 12: 56-day gap — longest in the dataset — spanning the onboarding launch, holiday period, and perf review.",
              "source_ref": "meeting_5206"
            },
            {
              "text": "7 meetings over ~7.5 months = average 32-day interval",
              "source_ref": null
            }
          ],
          "action": {
            "label": "Suggested Discussion Topic",
            "text": "Avery, I want to increase our 1-on-1 cadence to every two weeks. I think the monthly-ish rhythm we've had has let too many things slip — your career conversation, the ad-hoc request problem, workload concerns. Would every other week work for you, or would you prefer weekly for a while until we get back on track?",
            "variant": "default"
          }
        },
        {
          "title": "Critical events fell in meeting gaps",
          "priority": "medium",
          "body": "The onboarding redesign launched on December 16, during the 56-day gap between meetings. Avery didn't get to debrief the launch, celebrate the results, or discuss Q1 planning until nearly a month later. Major milestones deserve timely conversation — even a brief check-in call would have shown investment.",
          "evidence": [
            {
              "text": "Onboarding launched Dec 16. Next 1-on-1 was Jan 12 — 27 days later.",
              "source_ref": "meeting_5206"
            },
            {
              "text": "Avery noted disappointment that the launch wasn't celebrated or given visibility.",
              "source_ref": "meeting_5206"
            }
          ],
          "action": {
            "label": "Manager Action",
            "text": "When a report ships something significant, don't wait for the next scheduled 1-on-1. Send a message, do a quick call, or publicly celebrate within 48 hours. Timeliness is what makes recognition feel genuine.",
            "variant": "default"
          }
        }
      ]
    },
    {
      "name": "Energy Alignment",
      "icon": "🔥",
      "status": "warn",
      "insights": [
        {
          "title": "Design craft and user research are clear energizers",
          "priority": "positive",
          "body": "Avery comes alive when discussing design work: wireframing, user research, the design system. The user research sessions generated pride and excitement ('Really proud of these insights. First time running research end-to-end on my own.'). The design system work with Suki is described enthusiastically. When Avery talks about actual design craft — simplifying flows, documenting components, running research — the energy is high and self-directed.",
          "evidence": [
            {
              "text": "Sep 8: 'Really proud of these insights. First time running research end-to-end on my own.'",
              "source_ref": "meeting_5203"
            },
            {
              "text": "Design system: Avery chose atomic design methodology, partnered proactively with Suki, documented 12 high-quality components.",
              "source_ref": "work_summary_7207"
            },
            {
              "text": "Onboarding wireframes 'completed ahead of schedule' — self-initiated quality indicators like progressive disclosure approach.",
              "source_ref": "meeting_5201"
            }
          ],
          "action": {
            "label": "Keep Doing",
            "text": "Avery's best work happens when they're doing deep design craft — user research, system thinking, component architecture. Protect this time aggressively. The design system initiative is perfectly aligned with what energizes Avery.",
            "variant": "green"
          }
        },
        {
          "title": "Ad-hoc sales requests and bug fixes are clear energy drains",
          "priority": "medium",
          "body": "Ad-hoc sales requests are mentioned with consistent frustration across months. Settings page bug fixes are described as 'unplanned work but necessary.' These low-autonomy, reactive tasks pull Avery away from the strategic design work that generates energy and impact. The current mix is weighted too heavily toward draining work.",
          "evidence": [
            {
              "text": "Multiple meetings: Ad-hoc sales requests described with visible frustration, called a 'recurring distraction.'",
              "source_ref": "meeting_5203"
            },
            {
              "text": "Week of Jan 13: Settings page bugs described as 'unplanned work but necessary.'",
              "source_ref": "work_summary_7207"
            },
            {
              "text": "Week of Nov 10: 'Still getting 2-3 ad-hoc sales requests per week... Spent ~5 hours on custom mockups.'",
              "source_ref": "work_summary_7205"
            }
          ],
          "action": {
            "label": "Suggested Discussion Topic",
            "text": "Avery, if you could design your ideal workweek right now, what would you be spending your time on? I want to see how close we can get to that. I know the ad-hoc requests and bug fixes have been draining — let's figure out how to minimize those so you can focus on what you do best.",
            "variant": "default"
          }
        }
      ]
    },
    {
      "name": "Autonomy & Delegation",
      "icon": "🎯",
      "status": "warn",
      "insights": [
        {
          "title": "Avery operates with high autonomy — but needs more support, not less",
          "priority": "medium",
          "body": "At ~11 months tenure, Avery is in the coaching-to-supporting transition zone (S2→S3). The observed autonomy level is very high: Avery runs research solo, proposes design approaches, creates handoff documentation independently, and drives technical decisions. This is great for skill level but the support side is lacking. High autonomy without adequate backup (unresolved blockers, no career plan, no scope protection) feels like abandonment, not trust.",
          "evidence": [
            {
              "text": "Avery proposed merging account/workspace setup based on independent research — manager didn't need to direct this.",
              "source_ref": "meeting_5203"
            },
            {
              "text": "Avery created competitive audit, Figma handoff with annotations, research report — all self-directed.",
              "source_ref": "work_summary_7204"
            },
            {
              "text": "Oct 6: Morgan suggested Avery push back on sales VP directly — delegating conflict without providing cover.",
              "source_ref": "meeting_5204"
            }
          ],
          "action": {
            "label": "Suggested Discussion Topic",
            "text": "Avery, I think you've earned a lot of autonomy and I trust your judgment. But I want to make sure the independence feels like trust and not like I'm leaving you to fend for yourself. Where do you want me more involved, and where do you want me to stay out of the way?",
            "variant": "default"
          }
        },
        {
          "title": "Decision ownership is report-driven — which is appropriate but under-supported",
          "priority": "positive",
          "body": "Technical decisions (design approaches, methodologies, user research) are almost entirely report-driven. Avery proposes solutions and Morgan approves. Priority setting is nominally shared but in practice Morgan assigns projects and Avery self-manages the execution. Problem identification is strongly report-driven — Avery surfaces issues that Morgan then (slowly) addresses. This pattern is healthy for the autonomy dimension but highlights the support gap.",
          "evidence": [
            {
              "text": "Jul 14: Avery walked through wireframes with a specific proposal (7→4 step reduction, progressive disclosure). Morgan approved.",
              "source_ref": "meeting_5201"
            },
            {
              "text": "Design system: Avery chose atomic design methodology and partnered with Suki proactively.",
              "source_ref": "work_summary_7207"
            },
            {
              "text": "All major concerns (ad-hoc requests, burnout, career) were raised by Avery, not identified by Morgan.",
              "source_ref": null
            }
          ],
          "action": {
            "label": "Keep Doing",
            "text": "Avery's self-direction on design decisions is a strength. Continue giving them space on the how. Your role should shift toward shielding them from distractions, creating visibility for their work, and making organizational decisions (scope, priorities, promotion) that Avery can't make alone.",
            "variant": "green"
          }
        }
      ]
    },
    {
      "name": "Personal Connection",
      "icon": "💙",
      "status": "warn",
      "insights": [
        {
          "title": "No personal topics appear in any meeting",
          "priority": "medium",
          "body": "Across seven meetings over 7+ months, there are zero recorded personal touchpoints — no mentions of life outside work, hobbies, family, health, or personal events. Every meeting is 100% work-focused. While it's possible personal conversation happens off-record, the absence is notable. Avery is raising vulnerable concerns (burnout, career frustration, feeling invisible), which shows some trust — but a human connection beyond work topics would deepen that trust and help Morgan notice early warning signs.",
          "evidence": [
            {
              "text": "No meeting summaries, highlights, or topics include personal content across all 7 meetings.",
              "source_ref": null
            },
            {
              "text": "Avery does share emotional states in notes — burnout, frustration, pride — but these are work-contextualized, not personal.",
              "source_ref": "meeting_5207"
            }
          ],
          "action": {
            "label": "Suggested Discussion Topic",
            "text": "Start the next meeting with a genuine personal check-in before any work topics: 'How are you doing — not work stuff, just you? What's been going on in your life?' Even 3 minutes of this shifts the dynamic. Over time, knowing what matters to Avery outside work will help you be a better manager.",
            "variant": "default"
          }
        },
        {
          "title": "Mood trajectory shows declining trend",
          "priority": "medium",
          "body": "While formal mood data isn't captured, Avery's notes reveal a clear emotional arc: proud and hopeful in July-August, frustrated but constructive in September-October, relieved but still uncertain in November, and approaching a breaking point by February (burnout + flight risk language). Without personal connection data, it's harder to disentangle work frustration from broader life context.",
          "evidence": [
            {
              "text": "Jul 14: 'Feeling good about the direction.' — Positive",
              "source_ref": "meeting_5201"
            },
            {
              "text": "Oct 6: 'This has been going on for 3 months now.' — Frustrated",
              "source_ref": "meeting_5204"
            },
            {
              "text": "Feb 24: 'I love the work here but I'm starting to look at what's out there.' — Flight risk",
              "source_ref": "meeting_5207"
            }
          ],
          "action": {
            "label": "Suggested Discussion Topic",
            "text": "Avery, I want to check in with you beyond the usual project updates. How are you feeling — about the job, the team, your future here? I've noticed some frustration building up and I want to make sure we address the root causes, not just the symptoms.",
            "variant": "default"
          }
        }
      ]
    },
    {
      "name": "Meeting Structure",
      "icon": "📋",
      "status": "warn",
      "insights": [
        {
          "title": "Career and growth topics keep getting squeezed out",
          "priority": "high",
          "body": "A pattern is visible: career topics are consistently the last item on the agenda and get tabled when time runs short. In September, the career discussion was explicitly cut because they 'ran out of time.' In November, the discussion happened but was surface-level. The meeting structure doesn't protect time for the topics that matter most to Avery. Career and growth should be front-loaded or given a guaranteed time slot.",
          "evidence": [
            {
              "text": "Sep 8: Career development 'tabled' because they ran out of time.",
              "source_ref": "meeting_5203"
            },
            {
              "text": "Nov 17: Career discussion happened but was vague — no rubric, no plan.",
              "source_ref": "meeting_5205"
            },
            {
              "text": "Avery's note: 'This is the second time career growth got pushed off.'",
              "source_ref": "meeting_5203"
            }
          ],
          "action": {
            "label": "Manager Action",
            "text": "Restructure the 1-on-1 agenda: put career/growth topics in the first 15 minutes, not the last. Use this template: (1) Personal check-in 3 min, (2) Avery's priority topic 10 min, (3) Career/growth topic 10 min, (4) Project updates 5 min, (5) Action items 2 min. Protect the career slot like it's a deadline.",
            "variant": "default"
          }
        },
        {
          "title": "Topic distribution is heavily project-focused",
          "priority": "medium",
          "body": "Across all meetings, the dominant topics are project status (onboarding, settings page, design system) and blockers (ad-hoc requests). Career growth appeared in 3 of 7 meetings but was substantive in only 1. Feedback was positive-only. Personal connection was absent. The meetings function more as project check-ins than developmental 1-on-1s.",
          "evidence": [
            {
              "text": "Topic breakdown: ~50% project progress, ~20% blockers, ~15% career (mostly surface), ~15% priority setting. 0% personal, 0% constructive feedback.",
              "source_ref": null
            }
          ],
          "action": {
            "label": "Suggested Discussion Topic",
            "text": "Avery, I want to shift how we use our 1-on-1 time. Project updates are important but we can cover some of that async. I want to make sure we're using this time for the things only a live conversation can do — your career, your concerns, feedback in both directions. Would you be open to trying a new format?",
            "variant": "default"
          }
        }
      ]
    },
    {
      "name": "Expectations Tracker",
      "icon": "🎯",
      "status": "warn",
      "insights": [
        {
          "title": "Settings page goal is overdue with no updated plan",
          "priority": "medium",
          "body": "The settings page redesign goal had a due date of January 31, 2026 and is currently at 60% progress. It's now over a month past due with no recorded discussion of the revised timeline. The delay is understandable given the onboarding redesign priority and ad-hoc requests, but the expectation was never formally adjusted. Avery may feel like they're 'behind' on something that was never realistically scoped.",
          "evidence": [
            {
              "text": "Settings page goal: 60% progress, due date Jan 31 2026 — now overdue.",
              "source_ref": "goal_3202"
            },
            {
              "text": "Aug 11: Settings page work pushed to September — 'no discussion of how this affects the original timeline.'",
              "source_ref": "meeting_5202"
            }
          ],
          "action": {
            "label": "Suggested Discussion Topic",
            "text": "Avery, the settings page goal was originally due January 31 — let's formally adjust the timeline to reflect reality. Given the design system priority, what's a realistic new target? I don't want you carrying a 'late' goal that was delayed by decisions we made together.",
            "variant": "default"
          }
        },
        {
          "title": "Design system goal is at risk due to workload",
          "priority": "medium",
          "body": "The design system goal (30 components by April 30) is at 40% (12 components) with about 8 weeks remaining. At the current pace of ~3 components per week when focused, completion is achievable — but Avery is also carrying settings page bugs and ad-hoc requests. Without scope reduction, this goal is at risk.",
          "evidence": [
            {
              "text": "Design system: 12 of 30 components documented. Due April 30. 40% complete.",
              "source_ref": "goal_3203"
            },
            {
              "text": "Feb 24: 'Quality is high but pace is slower than expected because Avery is also handling settings page bugs.'",
              "source_ref": "meeting_5207"
            }
          ],
          "action": {
            "label": "Suggested Discussion Topic",
            "text": "Avery, let's do a realistic check on the design system timeline. You're at 12 of 30 with 8 weeks left. If we clear the settings page bugs off your plate, is 30 components still realistic, or should we adjust the target to the most critical components first?",
            "variant": "default"
          }
        },
        {
          "title": "Completed onboarding goal deserves formal celebration",
          "priority": "positive",
          "body": "The onboarding redesign goal was completed at 100% — exceeding the 15% activation rate target with an 18% improvement. This is a significant accomplishment that was noted in the January meeting but never formally celebrated or used to build Avery's visibility. Completed goals should be marked, celebrated, and used as evidence in promotion discussions.",
          "evidence": [
            {
              "text": "Goal completed: 'Launched Dec 16. Activation rate up 18% — exceeded the 15% target!'",
              "source_ref": "checkin_6203"
            },
            {
              "text": "Jan 12: Morgan congratulated Avery but didn't create external visibility.",
              "source_ref": "meeting_5206"
            }
          ],
          "action": {
            "label": "Manager Action",
            "text": "Use the onboarding redesign as the anchor of Avery's promotion case. Write up the impact metrics, the process (discovery → research → design → handoff → launch), and share it with your manager. This is the 'consistent impact' evidence you couldn't articulate in November.",
            "variant": "green"
          }
        }
      ]
    },
    {
      "name": "Talk Ratio",
      "icon": "🎙️",
      "status": "good",
      "insights": [
        {
          "title": "Avery drives the majority of meeting topics — this is healthy",
          "priority": "positive",
          "body": "Based on meeting content analysis, Avery initiates most discussion topics: demoing wireframes, presenting research findings, raising workload concerns, asking about career growth. Morgan's contributions are primarily reactive (responding to updates, giving approval, acknowledging concerns). While formal talk ratios aren't measured, the pattern suggests Avery speaks more and drives the agenda — which is the ideal dynamic for a 1-on-1.",
          "evidence": [
            {
              "text": "Jul 14: Avery demoed wireframes and proposed the approach.",
              "source_ref": "meeting_5201"
            },
            {
              "text": "Sep 8: Avery presented research findings, raised ad-hoc concerns, and initiated career discussion.",
              "source_ref": "meeting_5203"
            },
            {
              "text": "Feb 24: Avery flagged burnout and asked directly about promotion.",
              "source_ref": "meeting_5207"
            }
          ],
          "action": {
            "label": "Keep Doing",
            "text": "The report-driven dynamic in your 1-on-1s is a strength. Avery brings topics, proposals, and concerns. Continue to let Avery drive — your role is to listen deeply, ask follow-up questions, and then act on what you hear.",
            "variant": "green"
          }
        },
        {
          "title": "Risk: Morgan's listening may not translate to action",
          "priority": "medium",
          "body": "While the talk ratio appears healthy, there's a risk that 'listening well' becomes a substitute for 'acting on what's heard.' Avery drives the conversation, Morgan responds empathetically, but follow-through is inconsistent. Listening without action can be more frustrating than not being heard at all.",
          "evidence": [
            {
              "text": "Sep 8: Morgan 'sympathized' with ad-hoc request problem — no action for another 2 months.",
              "source_ref": "meeting_5203"
            },
            {
              "text": "Feb 24: Morgan 'acknowledged the concern' about burnout — suggested a long weekend instead of scope changes.",
              "source_ref": "meeting_5207"
            }
          ],
          "action": {
            "label": "Manager Action",
            "text": "End each 1-on-1 by explicitly stating what you will do before the next meeting. Write it down. At the start of the next meeting, report back on your own action items before asking about Avery's. Model the accountability you want to see.",
            "variant": "default"
          }
        }
      ]
    },
    {
      "name": "Team Dynamics",
      "icon": "🤝",
      "status": "warn",
      "insights": [
        {
          "title": "Avery's collaboration network is very narrow",
          "priority": "medium",
          "body": "The data shows Avery working primarily alone, with only one named close collaborator (Suki, the frontend engineer on the design system). Other interactions are transactional: presenting to stakeholders, fielding questions from the dev team, receiving ad-hoc requests from sales. There's no mention of design peers, a design community of practice, or cross-functional partnerships beyond the immediate project. For a designer pursuing senior level, building influence across the organization is important.",
          "evidence": [
            {
              "text": "Only named collaborator: Suki (frontend engineer) on design system.",
              "source_ref": "work_summary_7207"
            },
            {
              "text": "User research was run solo — no research partner or observer.",
              "source_ref": "work_summary_7203"
            },
            {
              "text": "No mention of other designers, design critiques, or peer feedback sessions.",
              "source_ref": null
            }
          ],
          "action": {
            "label": "Suggested Discussion Topic",
            "text": "Avery, who are you working with most closely day to day? I want to make sure you have people to bounce ideas off — not just me. Are there designers or cross-functional partners you wish you had more connection with? Would a design critique ritual or pairing session help?",
            "variant": "default"
          }
        },
        {
          "title": "Avery may be the only designer on the team",
          "priority": "medium",
          "body": "The data suggests Avery may be the sole designer on the Product Design team, or at least the only one working on these initiatives. All design work — research, wireframing, hi-fi design, handoff documentation, design system, bug fixes — falls on Avery alone. This 'last one standing' pattern creates both a workload risk and a professional isolation risk. A designer without design peers misses out on critique, mentorship, and the creative energy that comes from collaborative design work.",
          "evidence": [
            {
              "text": "No other designer is mentioned across any meeting or work summary.",
              "source_ref": null
            },
            {
              "text": "All design deliverables across 3 projects are solely attributed to Avery.",
              "source_ref": null
            }
          ],
          "action": {
            "label": "Manager Action",
            "text": "If Avery is the sole designer, this is both a retention risk and a growth bottleneck. Consider: hiring a junior designer Avery could mentor (supports senior promotion case), connecting Avery with designers in other parts of the org, or establishing an external design community/mentorship. Avery needs design peers.",
            "variant": "default"
          }
        }
      ]
    }
  ],
  "agenda": {
    "next_meeting": [
      {
        "topic": "Career path: deliver a clear, honest answer on senior promotion",
        "tags": ["career", "critical", "decision"],
        "opener": "Avery, I owe you a straight answer on the senior designer path. I've talked to my manager, and here's where things stand..."
      },
      {
        "topic": "Workload triage: make concrete scope cuts",
        "tags": ["workload", "critical", "decision"],
        "opener": "You told me last time that you need fewer things on your plate — and you're right. I came prepared with a proposal for what to cut or defer. Here's what I'm thinking..."
      },
      {
        "topic": "Acknowledge the blocker response pattern and commit to doing better",
        "tags": ["psychological-safety", "trust"],
        "opener": "Avery, I want to own something — it took me too long to resolve the ad-hoc request problem, and my response to your burnout concern wasn't enough. When you raise an issue, I need to act faster. What else is in that category right now?"
      },
      {
        "topic": "Create visibility for the onboarding redesign success",
        "tags": ["recognition", "career"],
        "opener": "The onboarding redesign exceeded targets — 18% activation improvement is a big deal. I want to make sure this gets visibility beyond our team. Would you like to present at the next all-hands, or would you prefer we do a written case study?"
      },
      {
        "topic": "Share the written performance review",
        "tags": ["feedback", "expectations"],
        "opener": "I should have shared this sooner — here's your written performance review. Let's walk through it together."
      },
      {
        "topic": "Design system goal reality check",
        "tags": ["expectations", "goals"],
        "opener": "You're at 12 of 30 components with 8 weeks left. If we clear the other distractions, is this still realistic? What's the minimum viable scope?"
      },
      {
        "topic": "Increase meeting cadence to biweekly",
        "tags": ["frequency", "process"],
        "opener": "I want to meet every two weeks going forward — our current cadence has let too many important things slip. Would that work for you?"
      },
      {
        "topic": "Personal check-in: how are you doing beyond work?",
        "tags": ["personal", "rapport"],
        "opener": "Before we get into anything else — how are you doing? Not work stuff, just you. What's going on in your world?"
      }
    ],
    "phased_plan": [
      {
        "meeting": "Meeting 1 — Repair & Reset",
        "theme": "Acknowledge what's broken, make immediate decisions, rebuild trust",
        "topics": [
          "Personal check-in — start building a human connection beyond work",
          "Own the pattern: acknowledge slow blocker response, career ambiguity, and insufficient burnout response",
          "Deliver a clear answer on senior promotion timeline and what's needed",
          "Make concrete workload cuts: propose pausing settings page bugs and fully blocking ad-hoc requests",
          "Share the written performance review",
          "Commit to biweekly cadence and a new meeting structure",
          "End with explicit action items for both sides — Morgan's items first"
        ]
      },
      {
        "meeting": "Meeting 2 — Career Architecture",
        "theme": "Build the development plan that should have existed months ago",
        "topics": [
          "Personal check-in and mood check",
          "Review action items from Meeting 1 — did Morgan follow through?",
          "Co-create a written development plan for senior designer: specific skills, milestones, timeline",
          "Add a growth-oriented goal alongside the delivery goals",
          "Plan visibility: schedule onboarding case study presentation or all-hands slot",
          "Design system progress check — is the adjusted scope working?",
          "Discuss peer connections: design critique ritual, external mentorship, or hiring plans"
        ]
      },
      {
        "meeting": "Meeting 3 — Sustainable Rhythm",
        "theme": "Confirm the new patterns are working, shift to forward-looking mode",
        "topics": [
          "Personal check-in",
          "Workload check: is the pace sustainable now? Are scope cuts holding?",
          "Development plan progress: first milestone check-in",
          "Give specific constructive feedback on one growth area identified in the development plan",
          "Energy alignment: is the current work mix energizing or draining?",
          "Ask for upward feedback: 'What's one thing I could do differently as your manager?'",
          "Discuss whether Avery wants to mentor a junior designer if hiring is possible"
        ]
      }
    ]
  }
}
